import angular from 'angular';
import Popup from '../../../../../common/services/popup';
import screenshareModalTemplateUrl from './doctor-screenshare-popup.modal.ngtemplate.html';
class DoctorScreensharePopup extends Popup {
    constructor($rootScope, $modal) {
        super();
        this.$rootScope = $rootScope;
        this.$modal = $modal;
        this.templateUrl = '';
        this.contentTemplateUrl = screenshareModalTemplateUrl;
    }
    open(data) {
        super.open(data);
    }
}
export default angular
    .module('doxy.common.services.doctorScreensharePopup', [])
    .service('doctorScreensharePopup', DoctorScreensharePopup).name;
